import React from 'react'
import {Link} from 'gatsby'

import Layout from '../components/layouts/layout'
import BasicPageHeading from '../components/basic-page-heading'
import Button8 from '../components/button8'

export default () => (
  <Layout
    title='About - Augmented Reality is for Everyone | Company Culture, Careers'
    description='8th Wall is the world’s leading WebAR development platform. We believe that augmented reality is for everyone, and we’re working hard to make AR content more accessible to all. We’re hiring!'
  >
    <BasicPageHeading>
      About Us
    </BasicPageHeading>

    <section className='light'>
      <div className='row justify-content-center'>
        <div className='col-lg-8 col-md-10 col-sm-12'>
          <p className='text8-md'>
            At 8th Wall, we believe that augmented reality is for everyone. We’re breaking barriers
            between the digital and physical, and bridging the development gap between iOS and
            Android, so that anyone can experience the magic of AR—no matter what device they’re
            on, all with no app required. With a dream team of computer vision engineers, designers
            and tinkerers at the helm, we care deeply about creating the tools developers, agencies
            and brands need to make immersive web content everyone can enjoy.
          </p>
          <p className='text8-md'>
            See how our tools are being used and follow our journey on our <a href='/blog'>blog</a>.
          </p>
        </div>
      </div>
    </section>
    <section>
      <div className='d-flex justify-content-center align-items-center flex-column'>
        <h2>Interested in joining our team?</h2>
        <Link to='/careers'>
          <Button8>
            Apply today
          </Button8>
        </Link>
      </div>


    </section>
  </Layout>
)
